module.exports = "<div class=\"full-height\" id=\"site-pairing-app\">\n    <h3 class=\"module-header\" id=\"site-pairing-header\" style=\"margin-top: 1rem; margin-left: 14px;\">\n        <span style=\"margin-left:8px;\">Site Pairing</span>\n    </h3>\n    <iframe class=\"embedded-content-view\" name=\"site-pairing-embed\" [src]=\"iframeUrl\"\n            frameborder=\"0\">\n    </iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sitepairing/site-pairing-embed.html
// module id = 4Utc
// module chunks = 0